import {Component, h, Fragment} from "preact";
import {Modal} from "../../_common/components/modal";
import {t} from "../../_i18n";
import {fetchApplications} from "../../_rx/jobs/actions";
import {connect} from "react-redux";
import {C, E} from "../../_common/layout";
import Badge from "../../_common/components/Badge";


type PropsReact = {
    candidateReducer: any,
    id: any
}


class View extends Component<PropsReact, { }> {
    constructor(props: any) {
        super(props);
    }

    render = ({candidateReducer: {candidate}, id}: PropsReact) => (candidate) &&
        <Modal id={id} title={
        <span>{t('Cuestionario de inscripción')}
            {candidate.hasKillerGrade && <Badge type='warning' className='light'><span>{candidate.killerGrade} %</span></Badge>}
        </span>} className="md-no-fullscreen">
        <hr className="separator-xxs"/>
        <div className="in-modal-scroll">
            <E>
                {candidate.questions.map((question: any, index: any) => <Fragment>
                    <h3>{question.text}</h3>
                    {question.answers.map((answer: any, index: any) => <span>{answer.text}</span>)}
                    {(candidate.questions.length !== index+1) && <hr className="separator-xxs"/>}
                    </Fragment>
                )}
                <div className='m-bottom m-top'/>
            </E>

        </div>
    </Modal>

}

const ConnectedView: any = connect(
    ({fixtures, candidateReducer}:any)=>({fixtures, candidateReducer}), {fetchApplications})(View as any);


export default ({id}: any) =>
    <ConnectedView id={id}/>
;